import * as types from '../dashboardActionTypes';

export default function logsPerDayLoadingReducer(state = true, action) {
    switch(action.type) {
        case types.LOAD_LOGS_PER_DAY:
            return true;
        case types.LOAD_LOGS_PER_DAY_FAILED:
        case types.LOAD_LOGS_PER_DAY_SUCCESS:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/logsPerDayLoadingReducer.js